/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Injectable } from "@angular/core";
import { BlastWmks } from "../../../shared/desktop/common/blast-wmks.service";

@Injectable()
export abstract class SessionLifeCycleService {
   public updateWMKSDPI = (key: string, dpi: number) => {};
   public addEventListener = (key, callback) => {};
   public init = (blastSession, blastSessionController) => {};
   public abstract getCurrentSession(): BlastWmks;
}
